import { configureStore } from '@reduxjs/toolkit';
import { studiosApi } from '../features/studios';
import { waitlistApi } from '../features/waitlist';
import { authApi, authReducer } from '../features/auth';
import { contactApi } from '../features/contact';
import { dashboardApi } from '../features/dashboard/dashboardApi';
import { paymentApi } from '../features/payment/paymentApi';
import { billingApi } from '../features/billing';
import { studioThemeApi } from '../api/studioThemeApi';
import { teamBiosApi } from '../api/teamBiosApi';
import { studentsApi } from '../api/studentsApi';
import { birthdayWidgetApi } from '../api/birthdayWidgetApi';
import { announcementsApi } from '../api/announcementsApi';
import { quickbooksApi } from '../api/quickbooksApi';
import { financialInsightsApi } from '../api/financialInsightsApi';
import { schedulingApi } from '../api/schedulingApi';
import { shoppingListApi } from '../api/shoppingListApi';
import { classEssentialsApi } from '../api/classEssentialsApi';
import { notificationsReducer } from '../features/notifications';
import studioContextReducer from '../features/studios/studioContextSlice';
import navigationReducer from '../features/navigation/navigationSlice';
import chatbotReducer from '../features/chatbot/chatbotSlice';
import { chatbotApi } from '../features/chatbot/chatbotApi';

export const store = configureStore({
  reducer: {
    [studiosApi.reducerPath]: studiosApi.reducer,
    [waitlistApi.reducerPath]: waitlistApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [studioThemeApi.reducerPath]: studioThemeApi.reducer,
    [teamBiosApi.reducerPath]: teamBiosApi.reducer,
    [studentsApi.reducerPath]: studentsApi.reducer,
    [birthdayWidgetApi.reducerPath]: birthdayWidgetApi.reducer,
    [announcementsApi.reducerPath]: announcementsApi.reducer,
    [quickbooksApi.reducerPath]: quickbooksApi.reducer,
    [financialInsightsApi.reducerPath]: financialInsightsApi.reducer,
    [schedulingApi.reducerPath]: schedulingApi.reducer,
    [shoppingListApi.reducerPath]: shoppingListApi.reducer,
    [classEssentialsApi.reducerPath]: classEssentialsApi.reducer,
    [chatbotApi.reducerPath]: chatbotApi.reducer,
    auth: authReducer,
    notifications: notificationsReducer,
    studioContext: studioContextReducer,
    navigation: navigationReducer,
    chatbot: chatbotReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(studiosApi.middleware)
      .concat(waitlistApi.middleware)
      .concat(authApi.middleware)
      .concat(contactApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(paymentApi.middleware)
      .concat(billingApi.middleware)
      .concat(studioThemeApi.middleware)
      .concat(teamBiosApi.middleware)
      .concat(studentsApi.middleware)
      .concat(birthdayWidgetApi.middleware)
      .concat(announcementsApi.middleware)
      .concat(quickbooksApi.middleware)
      .concat(financialInsightsApi.middleware)
      .concat(schedulingApi.middleware)
      .concat(shoppingListApi.middleware)
      .concat(classEssentialsApi.middleware)
      .concat(chatbotApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
